class Message {
  static error = 'error'
  static success = 'success'
  static info = 'info'

  constructor(message, type) {
    this.message = message
    this.type = type || Message.info
  }

  getType() {
    return this.type || Message.info
  }

  getMessage = () => {
    return this.message || ''
  }

  isError = () => {
    return this.type === Message.error
  }

  isSuccess = () => {
    return this.type === Message.success
  }
}

export default Message
